export default "__VITE_ASSET__DeLTGHM7__"